import axios from '@/utils/request'
import base from '../base'


export function ipWhiteList(data) {
    return axios.post(`${base.url}/auth/ipWhite/list`,JSON.stringify(data),{ headers: {'Content-Type': 'application/json'}});
}
export function pullIpWhiteList() {
    return axios.get(`${base.url}/auth/ipWhite/pull`);
}
export function editIpWhiteList(data) {
    return axios.post(`${base.url}/auth/ipWhite/edit`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function addIpWhiteList(data) {
    return axios.post(`${base.url}/auth/ipWhite/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function delIpWhiteList(id) {
    return axios.get(`${base.url}/auth/ipWhite/del?id=${id}`);
}
export function getRoutesIdList() {
  return axios.get(`${base.url}/auth/gateway/listAll`);
}

